import * as React from "react";
import styles from "app/components/ai-chat-assistant/styles.scss";
import { MdDeleteOutline } from "react-icons/md";

export const ChatFooter = ({
  clearChat,
  registerCase,
  translation,
  canRegisterCase
}: {
  clearChat: () => void, registerCase: () => void,
  translation: Record<string, string>,
  canRegisterCase: boolean
}) => (
  <div className={styles.chatFooter}>
    <button
      className={`btn btn-call-to-action ${styles.btnRegisterCase}`}
      onClick={() => registerCase()}
      disabled={!canRegisterCase}
    >
      {translation.textRegisterCase}
    </button>

    <button className={styles.clearChat} onClick={clearChat}>
      <MdDeleteOutline className={styles.clearChatIcon} />
      {translation.textClearChat}
    </button>

  </div>
);
